export default __webpack_public_path__ + "static/media/ourteambanner_1.93a09569.png";